module.exports = __webpack_public_path__ + "img/68.2742fa09.jpg";